import { render, staticRenderFns } from "./BlobFrame.vue?vue&type=template&id=bb79dd6c&scoped=true"
import script from "./BlobFrame.vue?vue&type=script&lang=js"
export * from "./BlobFrame.vue?vue&type=script&lang=js"
import style0 from "./BlobFrame.vue?vue&type=style&index=0&id=bb79dd6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb79dd6c",
  null
  
)

export default component.exports